
    import Vue from 'vue';
    import { setupAPM } from '@zyb/apm-vue';
    setupAPM(Vue, {"logErrors":false,"attachProps":false});
  